<template>
    <div class="detail">
        <div v-show="showDel" class="del-wrap fixed">
            <div class="inner">
                <span>提示</span>
                <span class="tc w100">确定删除该条数据吗？请谨慎操作</span>
                <div>
                <span class="btn" @click="toDel">确定</span>
                <span class="btn" @click="cancel">取消</span>
                </div>
            </div>
        </div>
        <div class="inner">
            <span class="btn btn-add" @click="add">新增</span>
            <span class="btn btn-ensure" @click="ensure">确定</span>
            <span class="btn btn-cancel" @click="$emit('close')">取消</span>
            <div class="head-wrap">
                <span class="title">详情-{{data.name}}</span>
                <div class="info-item">
                    <span>姓名：</span>
                    <input type="text" placeholder="请输入姓名" v-model="info.name">
                </div>
                <div class="info-item">
                    <span>地址：</span>
                    <input type="text" placeholder="请输入地址" v-model="info.address">
                </div>
                <div class="info-item">
                    <span>电话：</span>
                    <input type="text" placeholder="请输入电话" v-model="info.phone">
                </div>
                <div class="info-item">
                    <span>预定：</span>
                    <input type="text" placeholder="请输入预定量" v-model.number="info.order">
                </div>
                <div class="info-item">
                    <span>备注：</span>
                    <input type="text" :title="info.tip" placeholder="请输入备注" v-model="info.tip">
                </div>
            </div>
            <div class="detail-inner-wrap">
                <ListItem class="head-wrap" :isHead="true" :data="headOption"></ListItem>
                <el-scrollbar class="g-scroll">
                    <div class="dia-wrap">
                        <ListItem 
                            v-for="(item, index) in list"
                            :key="index"
                            :id="index"
                            @updateListItem="updateList($event, index)"
                            @onClick="onClick($event, index)"
                            :data="item"></ListItem>
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import { addRootItem, getNewItem, upgradeItem } from '@/utils/index';
export default {
    name: 'Detail',
    props: ['data'],
    components: {
        ListItem
    },
    data: function() {
        return {
            showDel: false,
            info: {
                name: '',
                phone: '',
                address: '',
                order: '',
                tip: ''
            },
            headOption: {
                name: '日期',   // 姓名
                address: '单价',    // 地址
                phone: '吨数',  // 电话
                totalPrice: '金额', // 总价
                sended: '是否付款',
                tip: '备注',
                op: '操作'
            },
            list: [],
            delIndex: ''
        }
    },
    computed: {
        isNew() {
            return !this.data.id;
        }
    },
    watch: {
        data: {
            handler(val) {
                const { name, address, phone, order, rest, tip } = val;
                this.info = {name, address, phone, order, rest, tip};
                this.list = val.list || [];
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        add() {
            this.list.push(getNewItem());
            this.$nextTick(() => {
                const target = document.querySelector('.detail-inner-wrap').querySelector('.el-scrollbar__wrap');
                this.scrollTarget(target);
            })
        },
        scrollTarget(target) {
            let time = 0;
            const timer = setInterval(() => {
                target.scrollTop += 11;
                time += 1;
                if(time == 4) {
                    clearInterval(timer);
                }
            }, 100);
        },
        onClick(type, index) {
            if(type =='del') {
                this.delIndex = index;
                // this.showDel = true;
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.toDel();
                }).catch(() => {
                        
                });
            }
        },
        cancel() {
            this.showDel = false;
        },
        toDel() {
            const data = this.data;
            if (!data.list) {
                this.list.splice(this.delIndex, 1);
                this.cancel();
                return;
            }
            data.list.splice(this.delIndex, 1);
            upgradeItem(data).then(() => {
                this.cancel();
                this.$message.success('删除成功');
                this.$emit('refresh');
            });
        },
        ensure() {
            const { name, phone, order, rest, tip, address } = this.info;
            if(this.isNew) {
                addRootItem({
                    name,
                    phone,
                    address,
                    order,
                    rest,
                    tip,
                    list: this.list
                }).then(() => {
                    this.$emit('refresh');
                    this.$emit('close');
                    this.$message.success('新增成功');
                    this.clearInfo();
                });
            } else {
                let data = this.data;
                data = Object.assign({}, data, {name, phone, rest, order, tip, address});
                upgradeItem(data).then(() => {
                    this.$emit('refresh');
                    this.$emit('close');
                });
            }
        },
        clearInfo() {
            this.info = {
                name: '',
                phone: '',
                address: '',
                order: '',
                rest: '',
                tip: ''
            }
        },
        updateList(item, index) {
            this.list[index] = item;
        }
    }
}
</script>

<style scoped>
.detail {
    position: fixed;
    left: 0;
    top: 0;
    padding: 60px;
    background: rgba(224, 211, 211, 0.5);
    z-index: 10;
    width: 100%;
    height: 100%;
}
.inner {
    width: 100%;
    height: 100%;
    background: #fff;
    position: relative;
    padding-bottom: 60px;
    padding-top: 160px;
    box-sizing: border-box;
}
.btn-add {
    position: absolute;
    right: 40px;
    top: 10px;
    z-index: 100;
}
.btn-ensure {
    position: absolute;
    left: 50%;
    transform: translateX(-120px);
    width: 80px;
    text-align: center;
    bottom: 10px;
}
.btn-cancel {
    position: absolute;
    left: 50%;
    transform: translateX(40px);
    width: 80px;
    text-align: center;
    bottom: 10px;
}
.inner .title {
    width: 100%;
    text-align: center;
    height: 60px;
    line-height: 60px;
}
.info-item {
    width: 33%;
    display: inline-flex;
    align-items: center;
    padding-left: 20px;
    height: 40px;
    margin-bottom: 10px;
}
.info-item input {
    padding: 0 10px;
    border: 1px solid #eee;
    width: 150px;
    height: 32px;
}
.dia-wrap {
    width: 100%;
    height: 100%;
}
.head-wrap {
    position: absolute;
    left: 0;
    top: 0;
}
.detail-inner-wrap {
    height: 100%;
    position: relative;
    padding-top: 40px;
    box-sizing: border-box;
}
.el-scrollbar__wrap {
    transition: all .3s ease;
}

</style>